import {ecSendData, trackEvent, sendFacebookConversionsEvent} from "../../library/analytics";
import {popupInfoDialog} from "../../library/info-dialog";
import {addToCartMultipleAjax} from "./add-to-cart-personalized";
import {sendFloodLightEvent, showShoppingCart} from "./product-shopping-cart";
import {addShowMoreDescriptionBtn, showMoreDescription} from "./show-more-description";
import {getDefaultFont, openModal} from "./modal-font";
import {getPriceFormat} from "./price-format";
import {configureHelpWidget} from "./help-widget";

window.addEventListener('load', () => {
    removeAll();
});

$(document).ready(function() {
    //text boxes expand on click
    $('#text-boxes').on('click', '.text-box', function() {
        let options = $(this).find('.text-options');
        if (options.is(':hidden')) {
            $('.text-options:visible').slideUp('fast');
            options.slideDown('fast');
        }
    });

    //render text on a press of the icon
    $('#text-boxes').on('click', '.text-show-btn', function() {
        let position = $(this).siblings('input').attr('id').replace('text-', '');
        let text = $(this).siblings('input').val();
        let fontFile = $('#text-font-file-'+position).val();
        let rightToLeft = $('#text-font-rtl-'+position).val();
        updateText(text, fontFile, rightToLeft, position, true);
    });

    $('#text-boxes').on('change', '.text-input input', function() {
        let position = $(this).attr('id').replace('text-', '');
        let text = $(this).val().trim();
        let fontFile = $('#text-font-file-'+position).val();
        let rightToLeft = $('#text-font-rtl-'+position).val();
        updateText(text, fontFile, rightToLeft, position, true);
        $(this).val(text);
        trackEvent('PersonalizedText', 'Text');
    });

    //dimensions change as asked when measure boxes are changed
    $('#text-boxes').on('change', '.text-width, .text-height', function(event) {
        if (!$.isNumeric($(this).val())) {
            $(this).val(0);
            return;
        }
        let position = $(this).attr('id').replace(new RegExp("text-width-visible-|text-height-visible-", "g"), '');
        $('#text-width-'+position).val($('#text-width-visible-'+position).val());
        $('#text-height-'+position).val($('#text-height-visible-'+position).val());
        calculateRatios($(this), position);
        previewText(position);
        updatePrice(position);

        if ($('#text-width-'+position).val() > 0 && $('#text-height-'+position).val() > 0) {
            trackEvent('PersonalizedText', 'Text sizes', $('#text-width-'+position).val() + ' x '+ $('#text-height-'+position).val());
        }
    });
    //blocks non-numbers and special keys on measure boxes
    $('#text-boxes').on('keypress', '.text-width, .text-height', function(event) {
        if ((event.which != 8 && event.which != 46 && event.which != 44 && isNaN(String.fromCharCode(event.which))) || event.which == 32) {
            event.preventDefault();
            return false;
        }
    });
    $('#text-boxes').on('change', '.text-keep-proportion', function(event) {
        let position = $(this).attr('id').replace(new RegExp("text-keep-proportion-", "g"), '');
        if ($('#preview-'+position).length) {
            previewText(position);
            if ($(this).is(':checked')) {
                $('#preview-' + position).width('auto').height('auto');
                $('#text-width-visible-'+position).change();
            }
        }
    });
    //open color modal
    $('#text-boxes').on('click', '.text-color-btn', function(event) {
        event.stopPropagation();
        let from = $(this).parents('.text-box').attr('id').replace('text-box-', '');
        $('#color-fired-from').val(from);
        $('.selected-color').removeClass('selected-color');
        let currentColor = $('#text-color-' + from).val();
        $('input[value="' + currentColor + '"][name="color-id"]').siblings('div').addClass('selected-color');
        $('#color-modal').modal();
    });
    //open font modal
    $('#text-boxes').on('click', '.text-font-btn', function(event) {
        event.stopPropagation();
        let from = $(this).parents('.text-box').attr('id').replace('text-box-', '');
        let currentFont = $(this).find('input').val().replace(new RegExp("'", "g"), "");

        openModal(from, currentFont);
    });
    //flips image when clicking the button
    $('#text-boxes').on('click', '.text-orientation-btn', function(event) {
        event.stopPropagation();
        let orientationBtn = $(this);

        if (orientationBtn.hasClass('disabled')) return;

        let orientation = $(this).find('input[type="hidden"]');
        if (orientation.val() == 'normal') {
            orientation.val('reversed');
            orientationBtn.css('background-color', '#2196f3');
            orientationBtn.css('color', '#ffffff');
        } else {
            orientation.val('normal');
            orientationBtn.css('background-color', 'inherit');
            orientationBtn.css('color', 'inherit');
        }
        previewText(orientation.attr('id').replace('text-orientation-', ''));
        trackEvent('PersonalizedText', 'Orientation', orientation.val());
    });
    //deletes text box
    $('#text-boxes').on('click', '.text-delete-btn', function(event) {
        event.stopPropagation();
        let position = $(this).parents('.text-box').attr('id').replace('text-box-', '');
        let preview = $('#preview-' + position);
        let txtBox = $('#text-box-' + position);
        preview.fadeOut('fast', function() {
            $(this).remove();
        });
        txtBox.slideUp('fast', function() {
            $(this).remove();
            updateTotalAmount();
            if (!$('.text-box').length){
                addTextBox();
            }
        });
        $('.text-box:first-child .text-options').slideDown('fast');
        trackEvent('PersonalizedText', 'Remove');
    });
    //color is selected on color modal
    $('.select-color').click(function() {
        let selectedColor = $(this);
        let from = $('#color-fired-from').val();
        let colorId = selectedColor.find('input[name="color-id"]').val();
        let colorHex = selectedColor.find('input[name="color-hex"]').val();
        let hardMaterial = selectedColor.find('input[name="hard-material"]').val();
        $('#hard-material-' + from).val(hardMaterial);

        let colorName = selectedColor.attr('title');
        let colorBtn = $('#text-box-' + from).find('.text-color-btn');
        $('#text-color-' + from).val(colorId).trigger('change');
        $('#text-colorHex-' + from).val(colorHex);

        colorBtn.css('color', colorHex);
        $('#preview-'+from).find('path').css('color', colorHex);
        previewText(from);
        $('#color-modal').modal('hide');
        trackEvent('PersonalizedText', 'Color', colorName);
        updatePrice(from);
    });
    //font is selected on font modal
    $('.select-font').click(function() {
        let from = $('#font-fired-from').val();
        let font = $(this).data('name');
        let fontFile = $(this).data('file');
        let rightToLeft = $(this).data('rtl');
        let text = $('#text-'+from).val();
        // Save font of 'from'
        $('#text-font-'+from).val(font);
        $('#text-font-file-'+from).val(fontFile);
        $('#text-font-rtl-'+from).val(rightToLeft);
        if ($('#text-height-visible-'+from).val()>0) {
            updateText(text, fontFile, rightToLeft, from, false);
        }
        $('#font-modal').modal('hide');
        trackEvent('PersonalizedText', 'Font', font);
    });
    //add a text box
    $('#add-text-btn').click(function() {
        addTextBox();
        trackEvent('PersonalizedText', 'AddText');
    });

    updatePreviewSizes();
    //blocks non-numbers and special keys on surface boxes
    $('#surface-width, #surface-height').keypress(function() {
        if((event.which != 8 && event.which != 46 && isNaN(String.fromCharCode(event.which))) || event.which == 32){
            event.preventDefault();
            return false;
        }
    });
    //updates surface when its measures change
    $('#surface-width, #surface-height').change(function() {
        let minSurfaceWidth = parseFloat($('#surface-width').attr('min'));
        let minSurfaceHeight = parseFloat($('#surface-height').attr('min'));
        if (parseFloat($('#surface-width').val()) < minSurfaceWidth) $('#surface-width').val(minSurfaceWidth);
        if (parseFloat($('#surface-height').val()) < minSurfaceHeight) $('#surface-height').val(minSurfaceHeight);
        updatePreviewSizes()
        if ($("#surface-height").val() > 0 && $("#surface-width").val() > 0) {
            trackEvent('PersonalizedText', 'Surface size', $("#surface-width").val() + ' x ' +$("#surface-height").val());
        }
    });
    //updates surface when resizing window
    $(window).resize(function(event) {
        if (event.target == window) {
            updatePreviewSizes();
        }
    });
    //changes surface color
    $('.preview-color').click(function() {
        let previewColor = $(this).css('background-color');
        $('#preview-content, .text-color-btn').css('background-color', previewColor);
        $('.preview-item .ui-resizable-handle').css('background-color', previewColor);
        trackEvent('PersonalizedText', 'PreviewColor', previewColor);
    });
    //opens options when an item is clicked
    $('#preview-content').on('click', '.preview-item', function(event) {
        let position = $(this).attr('id').replace('preview-', '');
        let textOptions = $('#text-box-' + position).find('.text-options');
        if (textOptions.is(':hidden')) {
            $('.text-options:visible').slideUp('fast');
            $('#text-' + position).focus();
            textOptions.slideDown('fast');
        }
    });
    //slides to tutorial
    $('#infoToTutorial').click(function() {
        $("html, body").animate({ scrollTop: $('#videotutorial-container').offset().top }, 1000);
        trackEvent('PersonalizedText', 'GoToTutorial');
    });

    $(document).on("click", ".btn-add-to-cart", function () {
        addToCart();
    });

    $(document).on('click', '.show-more-description-btn', function () {
        showMoreDescription(this);
    });
    addShowMoreDescriptionBtn();

    $(document).on('change', 'input[name="complement"], input[class="cross-selling-select-product"]', function () {
        if ($(this).is(':checked') && ($(this).data('name') || $(this).data('reference'))) {
            trackEvent('PersonalizedText', 'Complement', $(this).data('name') || $(this).data('reference'));
        }
    });

    $(document).on('click', '.description-btn', function () {
        trackEvent('PersonalizedText', 'Description', 'open/close');
    });

    $(document).on('change', 'input[name^="text-color"]', function () {
        let container = $(this).closest('.text-box');
        let color = $(this).val();
        let orientationInput = container.find('input[name^="text-orientation"]');
        let orientationBtn = container.find('.text-orientation-btn');
        let hardMaterialInput = container.find('input[name^="hard-material"]');

        if (hardMaterialInput.val() == "true") {
            orientationInput.val('normal');
            orientationBtn.css('background-color', '#e4e4e4');
            orientationBtn.css('color', '#666666');
            orientationBtn.addClass('disabled');
        } else if (orientationBtn.hasClass('disabled')) {
            orientationBtn.css('background-color', 'inherit');
            orientationBtn.css('color', 'inherit');
            orientationBtn.removeClass('disabled');
        }
    });

    $('.button-show-info').click(function() {
        let type = $(this).data('type');
        showInfoDialog(type);
    });

    configureHelpWidget();
});
//adds a textbox
function addTextBox() {
    let lastPosition = 0;
    if ($('.text-box').length) {
        lastPosition = $('.text-box:last-child').attr('id').replace('text-box-', '');
    }
    $.post(
        '/ajax/service/add-text-editor',
        {lastPosition: lastPosition},
        function(data) {
            $('#text-boxes').append(data.textBox);
            let newBox = $('#text-boxes .text-box:last-child');
            setTextBoxToDefaults(newBox);
            newBox.find('.text-color-btn').css('background-color', $('#preview-content').css('background-color'));
            newBox.slideDown('fast');
            // $('#add-btn-number').html(parseInt(lastPosition)+2);
        },
        'json'
    );
}
//resizes all items along the new surface dimensions
function updatePreviewSizes() {
    let surfaceWidth = $('#surface-width').val();
    let surfaceHeight = $('#surface-height').val();
    let preview = $('#preview-content');
    let newHeight = (surfaceHeight * preview.width()) / surfaceWidth;
    $('.x-size .surface-size').text(surfaceWidth);
    $('.y-size .surface-size').text(surfaceHeight);
    if (preview.height() != newHeight) {
        preview.height(newHeight);
        $('.text-box').each(function(){
            let position = $(this).attr('id').replace('text-box-', '');
            previewText(position);
        })
    }
    let previewWidth = parseFloat($('#preview-save').css('width').replace('px',''));
    $('.x-size').css('width', previewWidth + 'px');
    $('#preview-box').css('width', previewWidth - 21 + 'px');
}

function previewText(position) {
    let text = $('#text-' + position).val();
    if (text.length) {
        let width = $('#text-width-' + position).val();
        let height = $('#text-height-' + position).val();
        let surfaceWidth = $('#surface-width').val();
        let surfaceHeight = $('#surface-height').val();
        let pxSurfaceWidth = $('#preview-content').width();
        let pxSurfaceHeight = $('#preview-content').height();
        let orientation = $('#text-orientation-' + position).val();
        let colorHex = $('#text-colorHex-' + position).val();
        // let keepProportion = $('#text-keep-proportion-' + position).is(':checked');
        let keepProportion = true;

        if (!$('#preview-' + position).length) {
            $('#preview-content').append(
                "<div style='position:absolute;display:inline-block;border:1px dashed;' id='preview-" + position + "' class='preview-item'>" +
                "</div>"
            );
        }
        let previewTextContainer = $('#preview-' + position);
        let previewSVG = previewTextContainer.children();

        if (previewTextContainer.hasClass('ui-draggable')) previewTextContainer.draggable('destroy');
        if (previewTextContainer.hasClass('ui-resizable')) {
            previewTextContainer.resizable('destroy');
        }
        previewTextContainer.draggable({
            containment: "parent",
            start:function(event, ui) {
                $('input:focus').blur();
            }
        }).resizable({
            aspectRatio: keepProportion,
            containment: $('#preview-content'),
            handles: "se",
            start:function(event, ui) {
                $('input:focus').blur();
                ui.element.css('position','absolute');
            },
            resize: function(event, ui) {
                adaptSizes(position);
            },
            stop: function(event,ui) {
                updatePrice(position);
            }
        });
        previewSVG.css({
            'color': colorHex,
        });
        if (orientation == 'reversed') {
            previewTextContainer.addClass('text-mirrored');
        } else {
            previewTextContainer.removeClass('text-mirrored');
        }

        let tmpPxWidth = previewSVG.width();
        if (tmpPxWidth > pxSurfaceWidth) {
            tmpPxWidth = pxSurfaceWidth;
        }
        let tmpPxHeight = previewSVG.height();
        let pxHeight, pxWidth;

        if (!width) {
            if (height) {
                pxHeight = (height * pxSurfaceHeight) / surfaceHeight;
                pxWidth = (pxHeight * tmpPxWidth) / tmpPxHeight;
            } else {
                width = surfaceWidth / 2;
                pxWidth = (width * pxSurfaceWidth) / surfaceWidth;
            }
        } else {
            pxWidth = (width * pxSurfaceWidth) / surfaceWidth;
        }
        if (!height) {
            if (width) {
                pxWidth = (width * pxSurfaceWidth) / surfaceWidth;
                pxHeight = (pxWidth * tmpPxHeight) / tmpPxWidth;
            } else {
                height = tmpPxHeight * surfaceHeight / pxSurfaceHeight;
                pxHeight = (height * pxSurfaceHeight) / surfaceheight;
            }
        } else {
            pxHeight = (height * pxSurfaceHeight) / surfaceHeight;
        }

        previewTextContainer.width(pxWidth);
        previewTextContainer.height(pxHeight);
    } else {
        $('#show-text-price-' + position).text(0);
        $('#text-price-' + position).val(0);
        if ($('#preview-' + position).length) {
            $('#preview-' + position).fadeOut('fast', function() { $(this).remove(); } );
        }
    }
}

var updateAJAX;
var allReady = true;
function updatePrice(position){
    if (updateAJAX && typeof updateAJAX == 'object') {
        updateAJAX.abort();
    }
    let productId = $('#productId').val();

    let surfaceWidth = $('#surface-width');
    let surfaceHeight = $('#surface-height');

    let widthInput = $('#text-width-visible-' + position);
    let heightInput = $('#text-height-visible-' + position);
    let minSizeError = $('#min-size-error-' + position);
    let width = widthInput.val();
    let height = heightInput.val();
    let minWidth = parseFloat(widthInput.attr('min'));
    let minHeight = parseFloat(heightInput.attr('min'));
    let color = $('#text-color-' + position).val();

    if (width >= minWidth && height >= minHeight) {
        minSizeError.slideUp('fast');
        allReady = false;
        $('.btn-add-to-cart').attr('disabled', 'disabled');
        updateAJAX = $.post(
            '/ajax/product/calculate-custom-price',
            {
                productId: productId,
                width: width,
                height: height,
                quantity: 1,
                options: {
                    color: color
                },
            },
            function(data){
                let price = data.price;
                price = price.toFixed(2);

                $('#show-text-price-' + position).text(getPriceFormat(price));
                $('#text-price-' + position).val(price);

                if (parseFloat(surfaceWidth.val()) <= parseFloat(width)) {
                    surfaceWidth.val(parseFloat(width) + 10);
                }
                if (parseFloat(surfaceHeight.val()) <= parseFloat(height)) {
                    surfaceHeight.val(parseFloat(height) + 10);
                }

                updatePreviewSizes();
                updateTotalAmount();
                allReady = true;
                $('.btn-add-to-cart').removeAttr('disabled');
                updateAJAX = null;
            },
            'json'
        ).fail(function () {
            $('.btn-add-to-cart').removeAttr('disabled');
            updateAJAX = null;
        });
    } else {
        minSizeError.slideDown('fast');
        $('#show-text-price-' + position).text(0);
        $('#text-price-' + position).val(0);
    }
}

function updateTotalAmount(){
    let total = 0;
    $('.text-price-container input').each(function(){
        total = total + parseFloat($(this).val());
    });

    total = Math.round(total * 100) / 100;
    if (total != Math.floor(total)) {
        total = total.toFixed(2);
    }

    $('.btn-item-price').text(getPriceFormat(total));
}

function removeAll(){
    $('.text-box').each(function(){
        let textBox = $(this);
        setTextBoxToDefaults(textBox);
        $('.text-price-container input').val(0);
    });
    $('input[name="complement"], input[class="cross-selling-select-product"]').prop("checked", false);
    $('input[id="complement-491"]').prop("checked", true);
    $('.btn-item-price').html(0);
}

let items = [];
function addToCart() {
    let productId = $('#productId').val();
    let texts = [];
    let i = 0;
    let referrer = null;
    if (document.referrer.indexOf(location.protocol + "//" + location.host) === 0) referrer = document.referrer;

    if (productId && allReady) {
        $('.text-box').each(function(index) {
            let textBox = $(this);
            let position = $(this).attr('id').replace('text-box-', '');
            let text = textBox.find('.text-input').find('input').val().trim();

            if (text.length) {
                $('#preview-'+position).children().find('path').css('color','black');
                let width = textBox.find('.text-width').val();
                let height = textBox.find('.text-height').val();
                let color = textBox.find('.text-color-btn').find('input[name^="text-color-"]').val();
                let colorHex = textBox.find('.text-color-btn').find('input[name^="text-colorHex-"]').val();
                let mirrored = textBox.find('.text-orientation-btn').find('input').val() === 'reversed';
                let font = textBox.find('.text-font-btn').find('input[name^="text-font-"]').val();
                let fontFile = textBox.find('.text-font-btn').find('input[name^="text-font-file-"]').val();
                let rightToLeft = textBox.find('.text-font-btn').find('input[name^="text-font-rtl-"]').val();
                // let keepProportion = textBox.find('.text-keep-proportion').is(':checked');
                let keepProportion = true;

                texts[i] = {};
                texts[i]['productId'] = productId;
                texts[i]['quantity'] = 1;
                texts[i]['options'] = {};
                texts[i]['options']['width'] = width;
                texts[i]['options']['height'] = height;
                texts[i]['options']['color'] = color;
                texts[i]['options']['mirrored'] = mirrored;
                texts[i]['options']['reversed'] = false;
                texts[i]['options']['text'] = text;
                texts[i]['options']['personalizedText'] = text;
                texts[i]['options']['personalizedFont'] = font;
                texts[i]['options']['generateTextSvg'] = {
                    text: text,
                    fontFile: fontFile,
                    color: colorHex,
                    rightToLeft: rightToLeft,
                    forceSizes: !keepProportion,
                };
                texts[i]['options']['rightToLeft'] = rightToLeft;
                texts[i]['options']['referrer'] = referrer;

                if (index == 0) {
                    texts[i]['complements'] = [];
                    $('input[name="complement"]:checked').each(function(indexComplement) {
                        texts[i]['complements'].push({
                            id: $(this).data('id'),
                            locked: $(this).data('locked'),
                            'linkToParent': $(this).data('link-to-parent'),
                            'options': {
                                'width': $(this).data('width'),
                                'height': $(this).data('height'),
                                'device': $(this).data('device'),
                                'composition': $(this).data('composition')
                            }
                        });
                    });

                    let crossSellingProducts = [];
                    $('.cross-selling-select-product:checked').each(function() {
                        let product = $(this);
                        let options = {
                            'width': product.data('width'),
                            'height': product.data('height'),
                            'device': product.data('device'),
                            'composition': product.data('composition'),
                            'originalProduct': $('#productId').val(),
                            'personalizedImage': product.data('image'),
                            'color': product.data('color'),
                        };
                        if (product.data('material-color')) {
                            options['materialColor'] = product.data('material-color');
                        }
                        if (product.data('model')) {
                            options['model'] = product.data('model');
                        }
                        if (product.data('pack')) {
                            options['pack'] = product.data('pack');
                        }
                        crossSellingProducts.push(
                            {
                                'id': product.data('id'),
                                'options': options,
                                'locked': product.data('locked'),
                                'linkToParent': product.data('link-to-parent')
                            }
                        );
                    });
                    texts[i]['crossSellingProducts'] = crossSellingProducts;
                }
                i++;
            }
        });

        addToCartMultipleAjax(
            {
                products: texts,
                convertUM: true
            },
            function(data){successAddToCart(data)},
            function(data){failureAddToCart(data)}
        );
    }
}

function successAddToCart(data)
{
    let productName = 'Texto';
    $.each(data.cartItems, function(index, item){
        ecSendData(productName, productName, item.price, item.quantity, item.colorApaCode, item.size, 'normal', 'add', null);
        sendFloodLightEvent();
        if (window.fbq) {
            var payload = {
                content_type: 'product',
                content_name: productName,
                content_ids: [item.reference || ''],
                contents: [{id: item.reference || '', quantity: item.quantity, price: item.price || 0}],
                value: item.price || 0,
                currency: item.currency || ''
            };
            sendFacebookConversionsEvent('AddToCart', payload);
        }
        if (window.pintrk) {
            pintrk('track', 'AddToCart', {
                value: item.price,
                order_quantity: item.quantity,
                currency: item.currency
            });
        }
    });
    sendFloodLightEvent();
    trackEvent('PersonalizedText', 'AddToCart', data.length + " text(s)");
    removeAll();
    showShoppingCart();
}

function failureAddToCart(data)
{
    trackEvent('PersonalizedText', 'AddToCart', "error");
    popupInfoDialog(data.errorMessage);
}

var renderAJAX;
function renderText(text, fontFile, rightToLeft, position)
{
    if (renderAJAX && typeof renderAJAX == 'object') {
        renderAJAX.abort();
    }
    let target = $('#preview-'+position);
    renderAJAX = $.post(
        '/ajax/personalized-services/render-text',
        {
            text: text,
            fontFile: fontFile,
            rightToLeft: rightToLeft,
        },
        function(data){
            if (target.find('svg')) {
                target.find('svg').remove();
            }
            if (data.done) {
                target.prepend(data.svg);
                target.children().children().css('color', $('#text-colorHex-' + position).val());
                let viewBox = target.children()[0].getAttribute('viewBox').split(' ');
                target.css('height', viewBox[3]);
                target.css('width', viewBox[2]);
                let realH = target.children().height() * $('#surface-height').val() / $('#preview-content').height();
                let realW = target.children().width() * $('#surface-width').val() / $('#preview-content').width();
                let widthInput = $('#text-width-visible-' + position);
                let heightInput = $('#text-height-visible-' + position);
                let minWidth = parseFloat(widthInput.attr('min'));
                let minHeight = parseFloat(heightInput.attr('min'));
                $('#text-height-' + position).val(realH);
                heightInput.val((realH).toFixed(0));
                $('#text-width-' + position).val(realW);
                widthInput.val((realW).toFixed(0));
                if (realH < realW && realH < minHeight) {
                    heightInput.val(minHeight.toFixed(0));
                    heightInput.trigger('change');
                } else if (realW < realH && realW < minWidth) {
                    widthInput.val(minWidth.toFixed(0));
                    widthInput.trigger('change');
                }
                    widthInput.trigger('change');
                    heightInput.trigger('change');
            } else {
                let widthInput = $('#text-width-visible-' + position);
                popupInfoDialog(data.errorMessage, false, true);
                widthInput.val(0);
                widthInput.trigger('change');
            }
            previewText(position);
            updatePriceTimeout(position, 1);
        }
    )
    .always(function () {
        renderAJAX = null;
    });
}

function calculateRatios(textbox, position)
{
    // let keepProportion = $('#text-keep-proportion-'+position).is(':checked');
    let keepProportion = true;
    if (!keepProportion) return;
    let previewW = $('#preview-'+position).children().width();
    let previewH = $('#preview-'+position).children().height();
    let ratio = previewW*1 / previewH;
    if(textbox.hasClass('text-width')) {
        $('#text-height-'+position).val(textbox.val()/ratio);
        $('#text-height-visible-'+position).val((textbox.val()/ratio).toFixed(0));
    } else {
        $('#text-width-'+position).val(textbox.val()*ratio);
        $('#text-width-visible-'+position).val((textbox.val()*ratio).toFixed(0));
    }
}

function adaptSizes(position)
{
    let previewW = $('#preview-'+position).children().width();
    let previewH = $('#preview-'+position).children().height();
    let conversionW = $('#surface-width').val() / $('#preview-content').width();
    let conversionH = $('#surface-height').val() / $('#preview-content').height();
    $('#text-width-'+position).val(previewW * conversionW);
    $('#text-width-visible-'+position).val((previewW * conversionW).toFixed(0));
    $('#text-height-'+position).val(previewH * conversionH);
    $('#text-height-visible-'+position).val((previewH * conversionH).toFixed(0));


}

function updateText(text, fontFile, rightToLeft, position, append) {
    if (!$('#preview-' + position).length && append) {
        $('#preview-content').append(
            "<div style='position:absolute;display:inline-block;border:1px dashed;' id='preview-" + position + "' class='preview-item'></div>"
        );
    }
    renderText(text, fontFile, rightToLeft, position);
}

var updatePriceTimer;
function updatePriceTimeout(position, attempt) {
    if (updatePriceTimer) {
        clearTimeout(updatePriceTimer);
    }
    updatePriceTimer = setTimeout(function () {
        if ($('#text-height-'+position).val()>0) {
            updatePrice(position);
        } else if(attempt <= 5) {
            attempt = attempt + 1;
            updatePriceTimeout(position, attempt);
        }
    },500);
}

function setTextBoxToDefaults(textBox)
{
    let position = textBox.attr('id').replace('text-box-', '');

    $('#text-' + position).val(null);
    $('#show-text-price-' + position).html(0);
    $('#text-width-' + position).val(null);
    $('#text-width-visible-' + position).val(null);
    $('#text-height-' + position).val(null);
    $('#text-height-visible-' + position).val(null);
    $('#text-orientation-' + position).val("normal");
    textBox.find('.text-orientation-btn').css('background-color', 'inherit');
    textBox.find('.text-orientation-btn').css('color', 'inherit');
    textBox.find('.text-orientation-btn').removeClass('disabled');
    let defaultFont = getDefaultFont();
    $('#text-font-' + position).val(defaultFont.data('name'));
    $('#text-font-file-' + position).val(defaultFont.data('file'));
    $('#text-font-rtl-' + position).val(defaultFont.data('rtl'));
    $('#text-color-' + position).val(53);
    $('#text-colorHex-' + position).val("#000000");
    textBox.find('.text-color-btn').css('color', '#000000');

    if ($('#preview-' + position).length) $('#preview-' + position).fadeOut('fast', function() { $(this).remove(); } );
}

function showInfoDialog(type) {
    $.post(
        '/ajax/service/info-dialog',
        {type: type},
        function (data) {
            popupInfoDialog(data.content);
        },
        'json'
    );
}